/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            new Site().run();
        };
        Site.prototype.run = function () {
            Site.initResponsiveVideo();
            Site.initResponsiveTables();
            Site.initFrontpage();
            Site.initIcon();
            Site.initOne();
            Site.initStickyHead();
        };
        Site.is = function (bodyClass) {
            return document.body.classList.contains(bodyClass);
        };
        Site.initResponsiveVideo = function () {
            var iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
            Array.prototype.forEach.call(iframes, function (el) {
                var videoWrapper = document.createElement('div');
                videoWrapper.classList.add('video');
                videoWrapper.style.maxWidth = el.width;
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
                responsiveWrapper.parentNode.insertBefore(videoWrapper, responsiveWrapper);
                videoWrapper.appendChild(responsiveWrapper);
            });
        };
        Site.initResponsiveTables = function () {
            var tables = document.querySelectorAll('body:not(.admin) main table');
            Array.prototype.forEach.call(tables, function (el) {
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('table-responsive');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
            });
        };
        Site.initFrontpage = function () {
            if (!Site.is('frontpage')) {
                return;
            }
            Site.initOwlCarousel('.frontpage__news', {
                loop: false,
                dots: false,
                margin: 35,
                nav: true,
                navText: ["", ""],
                responsive: {
                    0: {
                        items: 1,
                    },
                    700: {
                        items: 2,
                    },
                    1100: {
                        items: 3,
                    },
                },
            });
        };
        Site.initOwlCarousel = function (id, options) {
            var $owl = $(id);
            if ($owl.length > 0) {
                $owl.addClass('owl-carousel');
                $owl.owlCarousel(options);
            }
        };
        Site.initIcon = function () {
            var icons = document.querySelectorAll('.icon.svg');
            Array.prototype.forEach.call(icons, function (el) {
                var icon = el.dataset['icon'];
                if (icon) {
                    var styles = "url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;";
                    el.setAttribute('style', "background: " + styles);
                }
            });
        };
        Site.initOne = function () {
            this.initFilters();
            this.initMeetings();
        };
        Site.initMeetings = function () {
            var meetings = document.querySelectorAll('.meetingListWrap table tbody tr');
            if (meetings.length > 0) {
                meetings.forEach(function (meeting) {
                    util.delegate(meeting, 'click', '.' + meeting.classList.value, function (e) {
                        e.preventDefault();
                        var link = meeting.querySelector('a');
                        window.location.href = link.href;
                    });
                });
            }
        };
        Site.initFilters = function () {
            var filters = document.querySelectorAll('#meetingBoxes select');
            if (filters.length > 0) {
                filters.forEach(function (filter) {
                    util.delegate(filter, 'change', '#' + filter.id, function (e) {
                        var target = e.target;
                        window.location.href = String(target.value);
                    });
                });
            }
        };
        Site.initStickyHead = function () {
            window.addEventListener('scroll', function (e) {
                var distanceY = window.pageYOffset || document.documentElement.scrollTop, shrinkOn = document.getElementById('header').getAttribute('data-shrinkOn');
                if (distanceY > parseInt(shrinkOn, 10)) {
                    $('body').addClass('stickyHead');
                }
                else {
                    $('body').removeClass('stickyHead');
                }
            });
        };
        return Site;
    }());
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
